import { AuthService } from "../services/authService";
import { resolveSoa } from "dns";
const requestUserType = "REQUEST_USER";
const receiveUserType = "RECEIVE_USER";
const initialState = { user: {}, userIsLoading: false };

export const actionCreators = {
  requestUser: () => async (dispatch, getState) => {
    dispatch({ type: requestUserType });

    const authService = new AuthService();
    const authedUser = await authService.getUserInfo();

    dispatch({ type: receiveUserType, user: authedUser });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === requestUserType) {
    return {
      ...state,
      userIsLoading: true
    };
  }

  if (action.type === receiveUserType) {
    const { user } = action;
    return {
      ...state,
      user: {
        ...user
        //roles: ["AccountManagement", "HierarchyManagement"]
        //roles: ["ReadOnly"]
      },
      userIsLoading: false
    };
  }

  return state;
};
